module.exports = __webpack_public_path__ + "static/7-39a651c97208f9dde2aea4cd813d31b4.jpg";